import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

import { Box, Stack, Typography } from '@sbv-clients/ui-shared';

const NoAccessState = () => {
  return (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
      alignItems="center"
      px={2}
    >
      <Box flex={1} />
      <Stack alignItems="center" spacing={1} maxWidth={420} textAlign="center">
        <LockOutlinedIcon
          sx={{ fontSize: 48, color: 'text.disabled', mb: 1 }}
        />
        <Typography
          sx={{ fontSize: 18, fontWeight: 600, color: 'text.primary' }}
        >
          You don't have access to anything yet
        </Typography>
        <Typography variant="body2" color="text.secondary">
          No pages are available for this profile. Contact your administrator if
          you think this is a mistake.
        </Typography>
      </Stack>
      <Box flex={2} />
    </Box>
  );
};

export default NoAccessState;
